import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import ProgressTracker from '../charts/ProgressTracker';
import PointIcon from '../icons/Point';
import ChallengeCardInfo from '../infomodals/ChallengeCardInfo';

export default function ActiveChallengeCard({uid, cid, details, photo, setOpenChallenge}) {
    const [open, setOpen] = useState(false);
    const handleOpen = () => {
        setOpen(true);
        setOpenChallenge(true); 
    }

    return (
        <div>
        <Box 
            className="activechallengecard-container" 
            onClick={handleOpen} 
            sx={{cursor: 'pointer',
                transition: 'box-shadow 0.5s, transform 0.5s',
                '&:hover' : {
                    transform: 'translate(-4px,-4px)',
                    boxShadow: '4px 4px var(--dark-yellow)',
                }
            }}>
            <Box alt={details.title} sx={{ width: '40%',  aspectRatio: 2, background: `var(--pri-yellow) url(${photo}) no-repeat top`, backgroundSize: 'cover' }} />
            <Box className="rewardcard-text-container">
                <Box className="spread-x" sx={{ alignItems: 'start', color: 'black' }}>
                    <Typography variant="body1" gutterBottom sx={{fontWeight: 'bold'}}>
                        {details.title}
                    </Typography>
                </Box>
                <Box className="spread-x" sx={{ gap: 1, color: 'black' }}>
                    <ProgressTracker 
                        withPopup={false} 
                        withLabel={false} 
                        isStreakType={(details?.type == 'weekly' || details?.type == 'day')}
                        streakType={details?.type}
                        streakCount={details?.streakCount} 
                        streakTotal={details?.frequencyRequired} 
                    />
                    <Box className="spread-x">
                        <Typography variant="body2">
                            {details.points}&nbsp;
                        </Typography>
                        <PointIcon />
                    </Box>
                </Box>
            </Box>
        </Box>
        <ChallengeCardInfo
            uid={uid} 
            cid={cid} 
            details={details} 
            photo={photo} 
            setOpenChallenge={setOpenChallenge} 
            setOpen={setOpen}
            open={open}
        />
        </div>
    );
}
